// DEPENDENCIES
import {
    OPEN_CONTACT_MODAL,
    CLOSE_CONTACT_MODAL,
    SEND_CONTACT_SUCCESS,
    SEND_CONTACT_FAILURE,
    OPEN_PAYING_METHODS_MODAL,
    CLOSE_PAYING_METHODS_MODAL,
    SEND_PAYING_SUCCESS,
    OPEN_CATEGORIES_MODAL,
    CLOSE_CATEGORIES_MODAL,
    OPEN_GENERAL_MESSAGE_MODAL,
    CLOSE_GENERAL_MESSAGE_MODAL,
    LOCATION_CHANGE,
    OPEN_VIDEO_MODAL,
    CLOSE_VIDEO_MODAL,
    OPEN_NAV_MODAL,
    CLOSE_NAV_MODAL,
    OPEN_LOADING_SPINNER,
    CLOSE_LOADING_SPINNER,
    OPEN_SPLASH_SCREEN_MODAL,
    CLOSE_SPLASH_SCREEN_MODAL,
    GET_SHARE_PIN_SUCCESS,
    OPEN_BAND_FINDER_PIN_MODAL,
    CLOSE_BAND_FINDER_PIN_MODAL,
    GET_MAP_PINS_SUCCESS,
    CLEAR_NEW_PIN_LIST,
    TOGGLE_MAP_TOP,
    SET_CHOSEN_DATE_LABEL,
    SET_COUNTRY_PIN_COUNT,
    CLEAR_COUNTRY_PIN_COUNT,
    TOGGLE_IS_SEARCH_LOCATION_MODE,
    CLEAR_PINS_LIST, INC_PIN_VIEW_COUNT_SUCCESS, TOGGLE_MOBILE_FILTER_BAR
} from '../Actions/main';

import {
    SAVE_SETTINGS_SUCCESS
} from '../Actions/admin';

import { MOBILE_MODE_MAP, MOBILE_MODE_GALLERY } from '../consts';
import { LocalStorageService } from "../Services";

const localStorageMainObject = LocalStorageService.getState('main') || {};

const { defaults = {} } = localStorageMainObject.datatypes || {};

const INITIAL_STATE = {
    pinsCount: 0,
    pages: 0,
    pinsNew: [],
    mapPins: [],
    mapPinsCount: 0,
    isContactModalOpen: false,
    isPayingMethodsModalOpen: false,
    isLoginModalOpen: false,
    isCategoriesModalOpen: false,
    isMobileFilterBar: false,
    filters: { type: 'liveMusic' },
    currentLocation: {},
    mode: (defaults && defaults.mobileMode) || MOBILE_MODE_GALLERY,
    isMapTop: localStorageMainObject.isMapTop,
    isSearchByNameMode: localStorageMainObject.isSearchByNameMode
};

export default function(state = INITIAL_STATE, action) {

    switch (action.type) {
        case GET_MAP_PINS_SUCCESS:
            return {
                ...state,
                mapPins: action.mapPins,
            };
        case 'GET_PINS_REQUEST':
            return {...state, isFetching: true};
        case 'GET_PINS_SUCCESS':
            return {
                ...state,
                pinsNew: [...action.pins],
                // pins: state.pins && state.pins.length < 1 ? action.pins.data.pins : state.pins,
                pinsCount: state.pinsCount + action.pins.length,
                pages: action.pages,
                isFetching: false
            };
        case 'GET_PINS_FAILURE':
            return {...state, isFetching: false};
        case CLEAR_PINS_LIST:
            return {
                ...state,
                pinsNew: [],
                pinsCount: 0,
                pages: 1,
                filters: {
                    ...state.filters,
                    category: '',
                    subCategory: '',
                    pageNumber: 0
                }
            }
        case CLEAR_NEW_PIN_LIST:
            return {
                ...state,
                pinsNew: [],
                pinsCount: 0,
                pages: 1,
                filters: {
                    ...state.filters,
                    pageNumber: 0
                }
            }

        case 'ADD_FILTER':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.filter]: action.value,
                    pageNumber: 0
                }
            };

        case 'RESET_FILTERS_TYPE':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    type: action.payload.type,
                    category: '',
                    subCategory: '',
                    pageNumber: 0,
                    location: null,
                    mapLocation: null,
                    iWeAre: ''
                }
            }

        case 'UPDATE_FILTERS':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    type: action.payload.type ? action.payload.type : state.filters.type, // action.payload.type,
                    category: action.payload.category ? action.payload.category : state.filters.category, // action.payload.category,
                    subCategory: action.payload.subCategory ? action.payload.subCategory : state.filters.subCategory, // action.payload.subCategory,
                    pageNumber: action.payload.pageNumber ? action.payload.pageNumber : state.filters.pageNumber, // action.payload.pageNumber
                }
            }
        case 'REMOVE_FILTER':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.filter]: '',
                    pageNumber: 0
                }
            };

        case 'CHANGE_LOCATION_ON_MAP':
            return {...state, currentLocation: {
                lat: action.lat,
                lng: action.lng
            }};
        case 'OPEN_PIN_MODAL':
            return {...state, isPinFullViewModalOpen: true, modalPinData: action.data, isBandFinderModalOpen: false};
        case 'CLOSE_PIN_MODAL':
            return {...state, isPinFullViewModalOpen: false};
        case OPEN_BAND_FINDER_PIN_MODAL:
            return {...state, isPinFullViewModalOpen: true, modalPinData: action.data, isModalOpen: false};
        case CLOSE_BAND_FINDER_PIN_MODAL:
            return {...state, isPinFullViewModalOpen: false};
        case 'TOGGLE_MODE':
            return {...state, mode: state.mode === MOBILE_MODE_MAP ? MOBILE_MODE_GALLERY : MOBILE_MODE_MAP};
        case 'GET_DATATYPES_REQUEST':
            return {...state, fetchingDatatypes: true};
        case 'GET_DATATYPES_SUCCESS':
            return {...state, datatypes: action.datatypes, fetchingDatatypes: false};
        case 'GET_DATATYPES_FAILURE':
            return {...state, fetchingDatatypes: false};
        case OPEN_CONTACT_MODAL:
            return {...state, isContactModalOpen: true};
        case CLOSE_CONTACT_MODAL:
            return {...state, isContactModalOpen: false};
        case SEND_CONTACT_SUCCESS:
            return {...state, isContactModalOpen: false};
        case SEND_CONTACT_FAILURE:
            // TODO: this should set flag for error notification
            return {...state};
        case OPEN_PAYING_METHODS_MODAL:
            return {...state, isPayingMethodsModalOpen: true};
        case CLOSE_PAYING_METHODS_MODAL:
            return {...state, isPayingMethodsModalOpen: false};
        case SEND_PAYING_SUCCESS:
            return {...state, isPayingMethodsModalOpen: false};
        case OPEN_CATEGORIES_MODAL:
            return {...state, isCategoriesModalOpen: true, catType: action.catType, catEdit: action.category};
        case CLOSE_CATEGORIES_MODAL:
            return {...state, isCategoriesModalOpen: false, catEdit: null};
        case OPEN_GENERAL_MESSAGE_MODAL:
            return {
                ...state,
                isGeneralMessageModalOpen: true,
                header: action.header,
                message: action.message,
                list: action.list,
                confirm: action.confirm,
                isCancel: action.isCancel
            };
        case CLOSE_GENERAL_MESSAGE_MODAL:
            return {...state, isGeneralMessageModalOpen: false};
        case SAVE_SETTINGS_SUCCESS:
            return {...state, datatypes: {...state.datatypes, defaults: action.settings}};
        case LOCATION_CHANGE:
            if (state.isNavModalOpen) {
                return {
                    ...state,
                    isNavModalOpen: false,
                    isModalOpen: true
                }
            }

            return {
                ...state,
                isPayingMethodsModalOpen: false,
                isModalOpen: false,
                isNavModalOpen: false,
                isBandFinderModalOpen: false
            };
        case OPEN_VIDEO_MODAL:
            return {...state, isVideoModalOpen: true};
        case CLOSE_VIDEO_MODAL:
            return {...state, isVideoModalOpen: false};
        case OPEN_NAV_MODAL:
            return {...state, isNavModalOpen: true};
        case CLOSE_NAV_MODAL:
            return {...state, isNavModalOpen: false};
        case GET_SHARE_PIN_SUCCESS:
            return {...state, isModalOpen: true, modalPinData: action.response.data};
        case OPEN_LOADING_SPINNER:
            return {...state, isLoadingSpinnerOpen: true};
        case CLOSE_LOADING_SPINNER:
            return {...state, isLoadingSpinnerOpen: false};
        case OPEN_SPLASH_SCREEN_MODAL:
            return {...state, isSplashScreenOpen: true};
        case CLOSE_SPLASH_SCREEN_MODAL:
            return {...state, isSplashScreenOpen: false};
        case 'USER_PINS_SUCCESS':
            return {...state, isLoadingSpinnerOpen: false};
        case TOGGLE_MAP_TOP:
            return {
                ...state,
                isMapTop: !state.isMapTop
            };
        case TOGGLE_IS_SEARCH_LOCATION_MODE:
            return {
                ...state,
                isSearchByNameMode: !state.isSearchByNameMode,
                filters: {
                    ...state.filters,
                    title: '',
                    location: null,
                    //mapLocation: null  TODO: should effect map ads?
                }
            };
        case SET_CHOSEN_DATE_LABEL:
            return {
                ...state,
                chosenDateLabel: action.chosenDateLabel
            }
        case SET_COUNTRY_PIN_COUNT:
            return {
                ...state,
                countryPinCount: { pinCount: action.pinCount, country: action.country }
            }
        case CLEAR_COUNTRY_PIN_COUNT:
            return {
                ...state,
                countryPinCount: {
                    ...state.countryPinCount,
                    pinCount: 0,
                    country: ''
                }
            }
        case INC_PIN_VIEW_COUNT_SUCCESS:
            // const pinsNew = [...state.pinsNew];
            // pinsNew.every(p => {
            //     if (p._id === action.pinId) {
            //         if (p.interactions) p.interactions.viewsCount++
            //         return false;
            //     }
            //
            //     return true
            // });

            return state
        case TOGGLE_MOBILE_FILTER_BAR:
            return {
                ...state,
                isMobileFilterBar: !state.isMobileFilterBar
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/Reducers/main.js